(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const boot = (scope = document) => {
    const heroes = [...scope.querySelectorAll('[data-shu-hero]')];
    if (scope.matches?.('[data-shu-hero]')) heroes.unshift(scope);
    heroes.forEach(hero => {
      if (hero._shuHeroDispose) return;
      const films = [...hero.querySelectorAll('[data-shu-film]')];
      if (!films.length) return;
      const buttons = [...hero.querySelectorAll('[data-shu-film-select]')];
      const mobile = matchMedia('(max-width: 749px)').matches;
      let selected = mobile && films.length > 1 ? 1 : 0;
      let inView = false, timer = 0, disposed = false, attempt = 0;
      const canPlay = () => !disposed && inView && !document.hidden && !reduced.matches && !navigator.connection?.saveData && document.documentElement.dataset.shAtmospherePaused !== 'true';
      const clear = () => { clearTimeout(timer); timer = 0; };
      const pauseAll = () => films.forEach(film => film.querySelector('video')?.pause());
      const refresh = () => {
        clear(); attempt++;
        const epoch = attempt;
        films.forEach((film, index) => {
          const current = index === selected;
          film.hidden = !current;
          film.classList.toggle('is-active', current);
          const video = film.querySelector('video');
          if (!video) return;
          video.muted = true; video.loop = true; video.playsInline = true;
          if (!current || !canPlay()) video.pause();
          else if (video.paused) {
            video.play()?.then(() => {
              if (disposed || index !== selected || !canPlay()) video.pause();
              if (epoch === attempt) hero.dataset.filmPlaying = 'true';
            }).catch(() => { if (epoch === attempt) hero.dataset.filmPlaying = 'false'; });
          }
        });
        buttons.forEach((button,index) => button.setAttribute('aria-pressed', String(index === selected)));
        if (canPlay() && hero.dataset.cycle === 'true' && films.length > 1) {
          timer = setTimeout(() => { selected = (selected + 1) % films.length; refresh(); }, Math.max(8000, Number(hero.dataset.speed) || 12000));
        }
      };
      const choose = event => {
        const button = event.target.closest('[data-shu-film-select]');
        if (!button || !hero.contains(button)) return;
        selected = Math.max(0, Math.min(films.length - 1, Number(button.dataset.shuFilmSelect) || 0));
        refresh();
      };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        inView = entries.some(entry => entry.isIntersecting); refresh();
      }, {threshold: .05}) : null;
      hero.querySelector('.shu-film-selector')?.removeAttribute('hidden');
      hero.addEventListener('click', choose);
      window.addEventListener('stillhigh:motionchange', refresh);
      document.addEventListener('visibilitychange', refresh);
      reduced.addEventListener('change', refresh);
      if (observer) observer.observe(hero);
      else { const bounds = hero.getBoundingClientRect(); inView = bounds.bottom > 0 && bounds.top < innerHeight; }
      refresh();
      hero._shuHeroDispose = () => {
        disposed = true; attempt++; clear(); pauseAll(); observer?.disconnect();
        hero.removeEventListener('click', choose);
        window.removeEventListener('stillhigh:motionchange', refresh);
        document.removeEventListener('visibilitychange', refresh);
        reduced.removeEventListener('change', refresh);
        delete hero._shuHeroDispose;
      };
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), {once:true}); else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-shu-hero]')) event.target._shuHeroDispose?.();
    event.target.querySelectorAll('[data-shu-hero]').forEach(hero => hero._shuHeroDispose?.());
  });
})();
